import { __decorate } from '../../../../node_modules/tslib/tslib.es6.mjs.js';
import '../../../../node_modules/@lit/reactive-element/reactive-element.js';
import { html as $ } from '../../../../node_modules/lit-html/lit-html.js';
import { LitElement as s } from '../../../../node_modules/lit-element/lit-element.js';
import { property as e } from '../../../../node_modules/@lit/reactive-element/decorators/property.js';
import '../../../../node_modules/@lit/reactive-element/decorators/query-assigned-elements.js';
import css_248z from './description-text.scss.js';
import { getStyleClassNames } from '../../utilities/constants/styles.constants.js';

class DescriptionText extends s {
    constructor() {
        super(...arguments);
        this.isRtl = false;
        this.text = '';
        this.fontSize = '1.5em';
        this.marginBottom = '1em';
        this.additionalClasses = '';
        this.textAlign = '';
    }
    render() {
        const textClassNames = getStyleClassNames({
            fontSize: this.fontSize,
            marginBottom: this.marginBottom,
            isRtl: this.isRtl,
            textAlign: this.textAlign,
            additionalClasses: this.additionalClasses,
        });
        return $ `<div class="description-text ${textClassNames}"><slot></slot></div>`;
    }
}
DescriptionText.styles = css_248z;
__decorate([
    e({ type: Boolean })
], DescriptionText.prototype, "isRtl", void 0);
__decorate([
    e({ type: String })
], DescriptionText.prototype, "text", void 0);
__decorate([
    e({ type: String })
], DescriptionText.prototype, "fontSize", void 0);
__decorate([
    e({ type: String })
], DescriptionText.prototype, "marginBottom", void 0);
__decorate([
    e({ type: String })
], DescriptionText.prototype, "additionalClasses", void 0);
__decorate([
    e({ type: String })
], DescriptionText.prototype, "textAlign", void 0);
customElements.define('description-text', DescriptionText);

export { DescriptionText };
